<template>
  <div class="page">
    <Breadcrumb title="财务对账" :breadcrumb="breadcrumb" />
    <detail-content :title="title">
      <div class="table" v-for="item of detail" :key="item.title">
        <Table
          :title="item.title"
          :data="detailTable"
          :header="item.tableHeader"
          :column-class-name="columnClassName"
        />
      </div>
    </detail-content>
    <detail-content class="error-list" title="差错处理" v-if="detailTable.results === '对账异常'">
      <div class="table">
        <el-table :data="errTableData" style="width: 100%" header-cell-class-name="table-header-cell">
          <el-table-column
            v-for="item of tableHeader"
            :key="item.label"
            :label="item.label"
            :width="item.width"
            :prop="item.prop"
            align="center"
          >
            <template v-if="item.children && Array.isArray(item.children)">
              <el-table-column
                v-for="el of item.children"
                :key="el.label"
                :prop="el.prop"
                :label="el.label"
                :width="el.width"
              ></el-table-column>
            </template>
            <template slot-scope="scope">
              <div class="btn-container">
                <router-link
                  tag="span"
                  class="btn"
                  :to="{ name: 'reconciliation/error/detail', params: { id: scope.row.id } }"
                >
                  查看详情
                </router-link>
                <span class="btn" v-if="['待处理'].includes(scope.row.processingState)" @click="updateState(scope.row)"
                  >修改状态</span
                >
                <!-- <span class="btn" v-if="['平台漏单'].includes(scope.row.errorType)" @click="reimburse(scope.row)"
                  >申请退款</span
                > -->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </detail-content>
    <div class="error-btn" v-if="detailTable.errorType">
      <!-- <el-button
        class="update"
        v-if="['待处理'].includes(detailTable.processingState)"
        type="primary"
        @click="updateState(detailTable)"
        >修改状态</el-button
      > -->
      <el-button class="back" @click="goBack">返回</el-button>
      <!-- <el-button class="refund" v-if="['平台漏单'].includes(detailTable.errorType)" plain>申请退款</el-button> -->
    </div>
  </div>
</template>

<script>
import { detail } from '@reconciliation/static/data.js';
import { openDialog } from '@reconciliation/static/mixin.js';
import { breadcrumb } from '@/mixins/index.js';
import Table from '@reconciliation/components/table.vue';
import DetailContent from '@reconciliation/components/detail-content.vue';
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'detail',
  mixins: [breadcrumb, openDialog],
  components: { Table, DetailContent },
  data() {
    return {
      tableHeader: [],
      detail: [],
      detailTable: {},
    };
  },
  computed: {
    ...mapGetters('reconciliat', ['recDetailTable']),
    ...mapGetters('error', ['errTableData', 'errDetailTable']),
    title() {
      this.getData();
      return detail.title.get(this.$route.name);
    },
  },
  methods: {
    ...mapActions('reconciliat', ['getDetail']),
    ...mapActions('error', ['getFailDetail', 'changeFailStatus', 'getErrorDetail']),
    columnClassName({ prop, value }) {
      if (prop === 'results' && value === '对账异常') {
        return 'error';
      }
    },
    // 获取对账详情
    async getData() {
      if (this.$route.name === 'reconciliation/list/detail') {
        await this.getDetail({
          id: this.$route.params.id,
        }).then(res => {
          if (res.results === '对账异常') {
            this.getFailDetail({
              batchNumber: res.batchNumber,
            });
          }
        });
        this.detailTable = this.recDetailTable;
      } else {
        await this.getErrorDetail({
          id: this.$route.params.id,
        });
        this.detailTable = this.errDetailTable;
      }
    },
    // 修改状态
    async updateFailState(params, row) {
      await this.changeFailStatus({
        id: row.id,
        remake: params.remark,
      }).then(res => {
        console.log(res);
        this.$message.success('操作成功，差错状态已更改');
      });
      await this.getData();
    },
    // 返回
    goBack() {
      this.$router.back(-1);
    },
  },
  created() {
    this.detail = detail.detailTable.get(this.$route.name);
    this.tableHeader = detail.handleError.get(this.$route.name);
  },
};
</script>

<style lang="less" scoped>
@import '~@reconciliation/static/common.less';
// 重写 element-ui 样式
/deep/.table-header-cell {
  background: #f8f8f8 !important;
  font-weight: 400;
  color: @font-color-secondary;
}
/deep/.el-table td {
  border-color: #f0f0f0;
}
/deep/.el-table--border th {
  border-color: #f0f0f0;
}
// 重写组件内样式
/deep/.error {
  color: @danger-color !important;
}

.page {
  height: 100%;
  .box_column();
}
.table {
  margin-top: 1.5em;
  .flex_layout(row, center, flex-start);
}
.error-list {
  margin-top: 15px;
  .table {
    padding: 0 40px;
  }
}
.btn-container {
  .flex_layout(row, space-between, flex-start);
  flex-wrap: wrap;
  color: @primary-blue;
  .btn {
    cursor: pointer;
    &:nth-child(2) {
      margin-right: 1em;
    }
    &:nth-child(3) {
      margin-top: 0.7em;
    }
  }
}
.error-btn {
  background: #fff;
  padding-bottom: 34px;
  text-align: center;
  .el-button {
    width: 100px;
    height: 40px;
    font-size: 14px;
    font-family: Helvetica;
    font-weight: 400;
    color: #4359b7;
    border-color: @primary-blue;
    margin-right: 20px;
  }
  .update {
    background: @primary-blue;
    color: #fff;
  }
  .back {
    border: none;
    background: #f5f5f5;
  }
}
</style>
